export const BehaviorActionType = {
  VIEW: 'view',
  VIEW_CATEGORY: 'view_category',
  VIEW_PRODUCT: 'view_product',
  CART: 'cart',
  ORDER: 'order'
} as const

export type BehaviorActionType = (typeof BehaviorActionType)[keyof typeof BehaviorActionType]

export const PageRankingPeriodType = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
} as const

export type PageRankingPeriodType =
  (typeof PageRankingPeriodType)[keyof typeof PageRankingPeriodType]

export interface BehaviorLog {
  id: number
  site_id: number
  visitor_id: string | null
  session_id: string | null
  customer_id: string | null
  item_id: string | null
  category_id: string | null
  action_type: BehaviorActionType
  device_type: string | null
  browser: string | null
  page_url: string | null
  referrer: string | null
  dwell_time_ms: number | null
  view_id: string | null
  product_variation_id: string | null
  brand_id: string | null
  feature_page_id: string | null
  feature_category_id: string | null
  created_at: string
}

export interface RankingAnalysisRequest {
  rankings: unknown[]
  period_type?: PageRankingPeriodType
}
